(function () {

  if (window.__crisChalkLoaded) return;
  window.__crisChalkLoaded = true;

  function createPath(width, shape) {

    const pts1 = [];
    const pts2 = [];

    if (shape === "wavy") {

      for (let i = 0; i <= 18; i++) {

        pts1.push([
          width * (i / 18),
          3 + Math.sin(i * 1.05) * 1.2
        ]);

        pts2.push([
          width * (i / 18),
          4 + Math.sin(i * 1.05 + .45) * .8
        ]);
      }

    } else if (shape === "scribble") {

      for (let i = 0; i <= 18; i++) {

        pts1.push([
          width * (i / 18),
          3 + (Math.random() * 2 - 1)
        ]);

        pts2.push([
          width * (i / 18),
          4 + (Math.random() * 1.2 - .6)
        ]);
      }

    } else {

      for (let i = 0; i <= 18; i++) {

        pts1.push([
          width * (i / 18),
          3 + Math.sin(i * .7) * .6
        ]);

        pts2.push([
          width * (i / 18),
          4 + Math.sin(i * .7 + .5) * .4
        ]);
      }

    }

    function smooth(points) {

      let d = `M${points[0][0]},${points[0][1]}`;

      for (let i = 1; i < points.length - 1; i++) {

        const xc = (points[i][0] + points[i + 1][0]) / 2;
        const yc = (points[i][1] + points[i + 1][1]) / 2;

        d += ` Q${points[i][0]},${points[i][1]} ${xc},${yc}`;
      }

      d += ` T${points[points.length - 1][0]},${points[points.length - 1][1]}`;

      return d;
    }

    return {
      d1: smooth(pts1),
      d2: smooth(pts2)
    };
  }

  function init() {

    document.querySelectorAll('[data-cris-chalk]').forEach(el => {

      const svg = el.querySelector('.cris-chalk-line');

      if (!svg) return;

      const p1 = svg.querySelector('.cp1');
      const p2 = svg.querySelector('.cp2');

      const draw = () => {

        const width = el.offsetWidth;

        svg.setAttribute('viewBox', `0 0 ${width} 8`);

        const path = createPath(
          width,
          el.dataset.shape || 'natural'
        );

        p1.setAttribute('d', path.d1);
        p2.setAttribute('d', path.d2);
      };

      draw();

      new ResizeObserver(draw).observe(el);

    });

  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();

})();